var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{style:('background-color:'+_vm.bgColor+';color:'+_vm.color+';'),attrs:{"id":"btn","disabled":_vm.disabled,"loading":_vm.loading,"block":""},on:{"click":function($event){return _vm.$emit('login')}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }